export default __webpack_public_path__ + "static/media/7.ffb8dc20.webp";